<template>
  <div class="FilteredData">
    <div>
      <Card :title="$t('advertisements.total')">
        <div class="Content">
          <p v-if="isEmpy" v-text="'N / A'"/>
          <p v-else v-text="this.selectedSector.amount " />
        </div>
      </Card>
      <Card :title="$t('advertisements.total-investment')">
        <p v-if="isEmpy" v-text="'N / A'" />
        <span v-else class="investment">
          <p v-text="this.selectedSector.investment" />
          <p class="dollar" v-text=" '$'"/>
        </span>
      </Card>
    </div>
    <div>
      <Card :title="this.title">
        <VariantDisplay :total="200" :changed="0" />
      </Card>
      <Card :title="$t('advertisements.average')">
        <p v-if="isEmpy" v-text="'N / A'" />
        <span v-else class="investment">
          <p v-text="this.selectedSector.average" />
          <p class="dollar" v-text="'$'"/>
        </span>

      </Card>
    </div>
  </div>
</template>

<script>
import { VariantDisplay } from 'daas-components';

import { Card } from '@/components';
import { LAST_THIRTY_DAYS } from '@/constants';
import EventBus from '@/utils/eventBus';

export default {
  name: 'FilteredAdvertisementsData',
  data() {
    return {
      title: this.$t(`date-picker.${LAST_THIRTY_DAYS}`),
      selectedSector: {},
    };
  },
  computed: {
    isEmpy() {
      return !this.selectedSector.average
    },
  },
  components: { Card, VariantDisplay },
  mounted() {
    EventBus.$on('ON_DATE_ADVERTISEMENTS', value => {
      this.selectedSector = value;
    });
  },
};
</script>

<style lang="scss">
.FilteredData {
  height: 25%;
  display: flex;
  justify-content: center;
  .Card {
    height: 40%;
    margin-top: rem(20);
    padding-left: rem(20);
    padding-right: rem(20);
    display: flex;
    justify-content: center;
    align-items: center;
    .Content {
      margin-left: rem(15);
      font-size: rem(35);
      font-weight: 700;
    }
    .VariantDisplay {
      font-size: rem(35);
      font-weight: 700;
    }
  }
  .investment{
    display: flex
  }
  .dollar{
    color:$blue-400;
    margin-left: rem(10);
  }
}
</style>
